// extracted by mini-css-extract-plugin
export var rightPanelOpenOld = "_9y-0";